// extracted by mini-css-extract-plugin
export var dropdownButton = "_1d-0";
export var fullWidthDropdownButton = "_1d-1";
export var icon = "_1d-3";
export var iconPlaceholder = "_1d-2";
export var menuItemRow = "_1d-9";
export var separator = "_1d-e";
export var shortcutContainer = "_1d-7";
export var shortcutContainerFilled = "_1d-8";
export var shortcutIconLg = "_1d-6";
export var shortcutIconMd = "_1d-5";
export var shortcutIconSm = "_1d-4";
export var submenuChevron = "_1d-d";
export var submenuDropdown = "_1d-a";
export var submenuTriggerRow = "_1d-b";
export var submenuTriggerRowOpen = "_1d-c";